import { render, staticRenderFns } from "./SugestionLineHint.vue?vue&type=template&id=dddd1568&scoped=true"
import script from "./SugestionLineHint.vue?vue&type=script&lang=js"
export * from "./SugestionLineHint.vue?vue&type=script&lang=js"
import style0 from "./SugestionLineHint.vue?vue&type=style&index=0&id=dddd1568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd1568",
  null
  
)

export default component.exports